<script>
  import BillItem from "./BillItem.svelte";
  export let billItemsList;

  //   let total = 0,
  //     t = 0;
  //   let temp =
  //   temp();
</script>

<style>
  #counter-list {
    width: 100%;
    margin: 0 auto;
  }
  thead {
    border: 2px solid rgb(146, 144, 143);
  }

  table {
    border: 1px dashed rgb(126, 124, 124);
    border-spacing: 0.5rem;
    padding: 3px;
    border-collapse: collapse;
  }
  td {
    padding: 2px;
  }

  .table-header {
    width: 100%;
    background-color: rgb(221, 221, 221);
    color: black;
    font-size: 10;
    font-weight: bold;
    border-radius: 12px;
    padding: 4px 2px;
    margin: 2px auto;
    text-align: center;
  }
</style>

<div id="counter-list">
  <table border="1">
    <thead>
      <tr style=" background-color: black;">
        <td class="table-header">Name</td>
        <td class="table-header">Price</td>
        <td class="table-header">Quantity</td>
        <td class="table-header">Del</td>
      </tr>
    </thead>
    <tbody>

      {#each billItemsList as calist, index}
        <BillItem
          key={index}
          catName={calist.catName}
          itemName={calist.itemName}
          itemPrice="{calist.itemPrice} SD"
          itemQuantity={calist.itemQuantity}
          itemImgPath={calist.itemImgPath}
          on:BillItemUpdate
          on:BillItemDelete />
      {/each}

    </tbody>
  </table>

</div>
